import React from 'react'
import { PageLocaleEnum } from 'common/enums/PageLocaleEnum'
import { formatDate } from 'common/utils/date-utils'
import {
  SearchResultsCardContainerUi,
  SearchResultsCardContentUi,
  SearchResultsCardDateUi,
  SearchResultsCardImageUi,
  SearchResultsCardImageWrapperUi,
  SearchResultsCardTitleLinkUi,
  SearchResultsCardTitleUi,
  SearchResultsCardUi,
} from './ui'
import { SearchResultImage } from 'common/types/search-interfaces'
import {
  SearchResultsCardInterface,
  SearchResultsCardTextInterface,
} from 'common/types/entities/search-results-interface'
import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'

interface SearchResultsCardProps {
  date: string | Date | null
  title: string
  content: string
  locale: PageLocaleEnum
  image: SearchResultImage | null
  path: string
  card: SearchResultsCardInterface
  cardTitle: SearchResultsCardTextInterface
  cardText: SearchResultsCardTextInterface
  cardDate: SearchResultsCardTextInterface
}

export const SearchResultsCard = (props: SearchResultsCardProps) => {
  const { t } = useTypedTranslation()

  return (
    <SearchResultsCardUi
      padding={props.card?.padding}
      mobilePadding={props.card?.mobilePadding}
      border={props.card?.border}
      mobileBorder={props.card?.mobileBorder}
      mobileBackgroundColor={props.card?.mobileBackgroundColor}
      backgroundColor={props.card?.backgroundColor}
    >
      <SearchResultsCardContainerUi>
        <SearchResultsCardTitleUi key={props.path} {...props.cardTitle}>
          <SearchResultsCardTitleLinkUi
            // biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation>
            dangerouslySetInnerHTML={{ __html: props.title }}
            href={props.path}
          />
        </SearchResultsCardTitleUi>
        <SearchResultsCardContentUi
          {...props.cardText}
          // biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation>
          dangerouslySetInnerHTML={{ __html: props.content }}
        />
        <SearchResultsCardDateUi {...props.cardDate}>
          {props.date
            ? formatDate(new Date(props.date), props.locale, {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
              })
            : t('components.search.not_specified')}
        </SearchResultsCardDateUi>
      </SearchResultsCardContainerUi>
      <SearchResultsCardImageWrapperUi hasImage={!!props.image?.path}>
        {!!props.image?.path && (
          <SearchResultsCardImageUi
            src={props.image?.path}
            alt={props.image?.filename}
          />
        )}
      </SearchResultsCardImageWrapperUi>
    </SearchResultsCardUi>
  )
}
